import React, { Component } from "react";

class Check extends Component {
  state = {};

  render() {
    const { id, title, narrative_text, parent_question_id,required_input,required_input_label } = this.props.item;
    const { i } = this.props;
    const sort_order =this.props.sort_order;
    const requiredInputValue = 1;
    return (
      <React.Fragment>
        <li>
          <div className="checbox">
            <input
              className="custom--checkbox"
              data-key={i}
              data-id={id}
              onChange={this.props.addCurrentOptionAnswers.bind(
                this,
                id,
                i,
                narrative_text,
                parent_question_id,
                required_input,
                sort_order
              )}
              id={"checkbox-" + i}
              data-order={this.props.sordt_order}
              type="radio"
              name="option"
              checked={this.props.checked}
            />
            <label htmlFor={"checkbox-" + i}>{title}
            {
              (this.props.checked && required_input==requiredInputValue) &&
              <div className={"custom-input-box"}>
                <input placeholder={required_input_label} className={"form-control custom-input"} id={id} onChange={this.props.addInputTextInOptionAnswers} value={this.props.displayInputText(id)} name="required_input"/>
              </div>
            }
            </label>
            
           
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default Check;
